import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import {
  entitiesBatch,
  postCompanyMap,
  updateCompanyMap,
  companiesSnapshots,
  POST_CONNECTED_COMPANIES,
} from './types';

import {
  requestPostCompanyMapSuccess,
  requestPostCompanyMapFailure,
  requestPostEntitiesBatchSuccess,
  requestPostEntitiesBatchFailure,
  requestUpdateCompanyMapSuccess,
  requestUpdateCompanyMapFailure,
  requestGetCompaniesSnapshotsSuccess,
  requestGetCompaniesSnapshotsFailure,
} from './reducer';

const logger = new Logger('Saga:Monitor');

export function* postEntitiesBatch(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.monitor.batch_start'),
      action.filePayload,
    );

    action.promise && action.promise.resolve(response.data);
    yield put(requestPostEntitiesBatchSuccess(response.data));
  } catch (error) {
    logger.info('Failed to get entities batch', error);
    action.promise && action.promise.reject(error);
    yield put(requestPostEntitiesBatchFailure(error));
  }
}

export function* requestUpdateCompanyMap(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.patch,
      routerService.generate('api.monitor.batch_by_id', { batchId: action.batchId }),
      action.companyMap,
    );

    action.promise && action.promise.resolve(response.data);
    yield put(requestUpdateCompanyMapSuccess(response.data));
  } catch (error) {
    logger.info('Failed to update company map', error);
    action.promise && action.promise.reject(error);
    yield put(requestUpdateCompanyMapFailure(error));
  }
}

export function* requestPostCompanyMap(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.monitor.batch_by_id_start', { batchId: action.batchId }),
    );

    action.promise && action.promise.resolve(response.data);
    yield put(requestPostCompanyMapSuccess(response.data));
  } catch (error) {
    logger.info('Failed to post company map', error);
    action.promise && action.promise.reject(error);
    yield put(requestPostCompanyMapFailure(error));
  }
}

export function* requestPostConnectedCompanies(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.monitor.batch_by_id_store', { batchId: action.batchId }),
      action.connectedCompanies,
    );

    action.promise && action.promise.resolve(response.data);
  } catch (error) {
    logger.info('Failed to post connected companies', error);
    action.promise && action.promise.reject(error);
  }
}

export function* getCompaniesSnapshots(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.monitor.batch_by_id', { batchId: action.batchId }),
    );

    action.promise && action.promise.resolve(response.data.snapshots);
    yield put(requestGetCompaniesSnapshotsSuccess(response.data));
  } catch (error) {
    logger.info('Failed to get companies snapshots', error);
    action.promise && action.promise.reject(error);
    yield put(requestGetCompaniesSnapshotsFailure(error));
  }
}

export default function* entitiesBatchSaga() {
  return yield all([
    takeLatest(entitiesBatch.request, postEntitiesBatch),
    takeLatest(postCompanyMap.request, requestPostCompanyMap),
    takeLatest(companiesSnapshots.request, getCompaniesSnapshots),
    takeLatest(updateCompanyMap.request, requestUpdateCompanyMap),
    takeLatest(POST_CONNECTED_COMPANIES, requestPostConnectedCompanies),
  ]);
}
